import { wire } from 'hyperhtml/umd';
import '@updater-components/cta';
import '../../../components/cta-bar';
import '../../../components/terminal-page-link';

import { when } from '../../../utils';
import { ROUTES as ROOT_ROUTES, ROUTES } from '../../../constants';
import { ROUTES as HOME_DETAILS_ROUTES } from '../../home-details/constants';
import { isLocal } from '../utils';

// TODO: Make `ROUTES.homeDetails` resolve to first home details route.
const NEXT_ROUTE = ROOT_ROUTES.homeDetails + HOME_DETAILS_ROUTES.homeSize;

const renderCTAs = route => (
  _,
  { parentRouter, getState, updStore }
) => html => {
  const { currentMove } = getState();
  // TODO: Explicitly pass `window.parent.document.referrer` in relevant widgets?
  const referrer = currentMove.referrer || window.parent.document.referrer;

  return html`
    <upd-moveiq-terminal-page-link updStore=${updStore} router=${parentRouter} page="intrastate" />
  `;
  // TODO: Commented out code below applied to the Intrastate "landing" page
  // Local and Interstate do not have a "landing" page experience any more.
  // The code below applies "currently" to the Widget experience only
  // Need to revisit the Widget implementation following the new MoveIQ phases

  // prettier-ignore
  // return html`
  //   <upd-moveiq-cta-bar
  //     id="ctaBar"
  //     type="${isLocal(route) ? 'footer' : '' }"
  //   >
  //       <upd-cta
  //         secondary
  //         class="${referrer ? '' : 'hide'}"
  //         aria-hidden="${!referrer}">
  //           <button
  //             onclick="${handleBack(referrer, currentMove, parentRouter)}"
  //             data-analytics-event="Landing Page Back Button"
  //           >
  //             Back
  //           </button>
  //       </upd-cta>

  //     ${when(isLocal(route), () => wire()`
  //       <upd-cta primary>
  //         <button
  //           onclick="${() => parentRouter.goTo(NEXT_ROUTE)}"
  //           data-analytics-event="Get Started"
  //         >
  //           Get Started
  //         </button>
  //       </upd-cta>
  //     `)}
  //   </upd-moveiq-cta-bar>
  // `;
};

function handleBack(referrer, currentMove, router) {
  return () => {
    if (currentMove.movingCompany) {
      // Using `parent` to cover scenario where we're IFramed.
      // If we aren't IFramed, `window.parent === window` anyway.
      window.parent.location.href = referrer;
    } else {
      router.goTo(ROUTES.homeSize);
    }
  };
}

export default renderCTAs;
